// Code Execution Tool
// Pure computation sandbox — no tool access
// Uses secure AST-based interpreter (safe-code-executor package)

import { createExecutor } from 'safe-code-executor'

/**
 * Execute user code in a sandboxed environment (computation/math only)
 * @param {Object} _ctx - unused
 * @param {Object} args - { code: string, timeout?: number }
 * @returns {Promise<Object>} Execution result
 */
export const executeCode = async (_ctx, args) => {
  const { code, timeout = 30000 } = args

  if (!code || typeof code !== 'string') {
    throw new Error('Code is required and must be a string')
  }

  const MAX_CODE_SIZE = 50000 // 50KB
  if (code.length > MAX_CODE_SIZE) {
    throw new Error(`Code exceeds maximum size (${MAX_CODE_SIZE} chars)`)
  }

  const actualTimeout = Math.min(timeout, 60000)

  const executor = createExecutor({
    timeout: actualTimeout,
    maxIterations: 10000,
  })

  const result = await executor.execute(code)

  if (!result.success) {
    console.error('[Code Executor] Execution failed:', result.error)
  }

  return result
}
